import omit from 'lodash/omit';

import {TPeriodPickerValue} from '@edna/components';
import {TCurrency, getPeriod} from '@edna/utils';

import {EChannelType, TItemId} from 'src/constants';
import {EClientStatus} from 'src/containers/ClientStatus/definitions';
import {ELicenseStatus} from 'src/containers/Licenses/definitions';
import {EDocumentType, TPaymentType} from 'src/containers/User';
import {enumToBooleanHash} from 'src/utils';

import {selectFilters, setFiltersAction} from './slice';

export type TSupportClient = {
  id: number;
  locale: string;
  companyName: string;
  currencyCode: TCurrency;
  createdAt: string;
  taxNumber: string;
  email: string;
  paymentData: {
    operBankAccount: string;
    corrBankAccount: string;
    bankName: string;
    taxNumber: string;
    kpp: string;
    bic: string;
    nonresident: boolean;
    postAddress: string;
    legalAddress: string;
    siteAddress: string;
  };
  paymentType: TPaymentType;
  contacts: {
    email: string;
    phone: string;
    country: string;
  };
  personalManagerId: number;
  personalManagerName: string;
  personalManagerEmail: string;
  personalManagerPhone: string;
  partnerId: number;
  resellerId: number;
  tenantId: number;
  supportEmail: string;
  offerContentUrl: string;
  vatNumber: string;
  registrationEmail: string;
  needAgreementConfirmation: boolean;
  temporaryBlocked?: boolean;
  unblockAt?: string;
  locked?: boolean;
  defaultCurrency: TCurrency;
};

export enum ESupportProfileTabs {
  PAYMENT = 'payment',
  LICENSE = 'license',
  REQUISITES = 'requisites',
  PRICING = 'pricing',
  CONFIGS = 'configs',
}

export const SUPPORT_PROFILE_TABS = Object.values(ESupportProfileTabs);

export enum EPaymentTab {
  REPLENISHMENT = 'replenishment',
  ACCOUNT_STATEMENT = 'accountStatement',
  DOCUMENTATION = 'documentation',
}

export enum ETransactionPaymentType {
  INIT = 'INIT',
  RENEWAL = 'RENEWAL',
}

export enum EBillingStatus {
  ON = 'ON',
  OFF = 'OFF',
}

export const LICENSES = omit(ELicenseStatus, ELicenseStatus.ACTIVE_DEBT);

export type TFilters = {
  filter: string;
  period: TPeriodPickerValue;
  resellerId?: TItemId;
  responsibleManagerId?: TItemId;
  tenantStatus?: Record<EClientStatus, boolean>;
  channels?: Record<EChannelType, boolean>;
  licenseStatus?: Record<ELicenseStatus, boolean>;
  documentType?: Record<EDocumentType, boolean>;
  billingStatus?: Record<EBillingStatus, boolean>;
};

export const LIST_CONFIG = {
  paginationConfig: {
    pageSize: 150,
  },
  filtersConfig: {
    defaultFilters: {
      filter: '',
      period: getPeriod('anytime'),
      responsibleManagerId: '',
      resellerId: '',
      tenantStatus: enumToBooleanHash(EClientStatus),
      channels: enumToBooleanHash(EChannelType),
      licenseStatus: enumToBooleanHash(LICENSES),
      documentType: enumToBooleanHash(EDocumentType),
      billingStatus: enumToBooleanHash(EBillingStatus),
    },
    action: setFiltersAction,
    selector: selectFilters,
  },
};

export enum ESolutionIdApproveStatus {
  ERROR = 'ERROR',
  DONE = 'DONE',
}

export type TRegisterSolutionIdResponse = {
  name: string;
  id: number;
  solutionId: string;
  tenantId: number;
  approveStatus: ESolutionIdApproveStatus;
  createdAt: string;
  updatedAt: string;
  statusComment: string;
};
